<div class="title">Availability Criteria</div>
<div class="work-space">
  <app-attribute-comparison #attComparisons [project]="project" [criteria]="criteria" [attribute]="attributeId">
  </app-attribute-comparison>
</div>
<div class="footer">
  <button type="button" (click)="Ok()" class="btn btn-sm btn-primary">Ok</button>
  <button type="button" (click)="Cancel()" class="btn btn-sm btn-primary">Cancel</button>
</div>
